import { useCallback } from "react";

import ToastContainer from "./source";

export default ToastContainer;

export const useToast = () => {
  const toast = useCallback(
    (...args: Parameters<typeof import("./source").toast>) => {
      const _toast = async (
        ...args: Parameters<typeof import("./source").toast>
      ) => {
        return (await import("./source")).toast(...args);
      };
      return _toast(...args);
    },
    []
  );

  const dismiss = useCallback(
    (...args: Parameters<typeof import("./source").dismiss>) => {
      const _dismiss = async (
        ...args: Parameters<typeof import("./source").dismiss>
      ) => {
        return (await import("./source")).dismiss(...args);
      };
      return _dismiss(...args);
    },
    []
  );

  return { toast, dismiss };
};
